"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasketProvider = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _common = require("../common");
var _hooks = require("../common/hooks");
var _jsxRuntime = require("react/jsx-runtime");
/** @deprecated Please use BasketProvider from libs instead. */
const BasketProvider = ({
  environment
}) => {
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    globalApiUrl,
    identityUrl,
    kpiApiUrl,
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi', 'identity', 'staticApi']);
  const {
    src
  } = (0, _hooks.useSpa)({
    environment,
    name: 'basket-provider'
  });
  const basketProviderData = (0, _react.useMemo)(() => ({
    appUrl: src,
    useLocalStorage: true,
    customerId,
    kpiApiUrl,
    staticApiUrl,
    identityUrl,
    currentLanguage: language,
    globalApiUrl,
    tenant
  }), [language, customerId, globalApiUrl, identityUrl, kpiApiUrl, src, staticApiUrl, tenant]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_common.Spa, {
      scriptOnly: true,
      environment: environment,
      name: "basket-provider"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
      suppressHydrationWarning: true,
      id: "basket-provider-data",
      type: "application/json",
      children: JSON.stringify(basketProviderData)
    })]
  });
};
exports.BasketProvider = BasketProvider;
